import { PropsWithChildren, useState } from "react";

import { AiOutlineClose } from "react-icons/ai";

import ModalLayout from "@/components/Layout/ModalLayout";

interface ConfirmModalProps extends PropsWithChildren {
  title: string;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

const ConfirmModal = ({
  children,
  title,
  onConfirm,
  onClose,
}: ConfirmModalProps) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalLayout variant="primary" onClose={loading ? () => {} : onClose}>
      <div className="relative flex w-[340px] flex-col sm:w-[400px]">
        {/* Header */}
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
          <h3 className="text-base font-bold text-gray-900">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="rounded-md p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 disabled:opacity-50"
          >
            <AiOutlineClose size={16} />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-6">
          <p className="break-keep text-sm leading-relaxed text-gray-600">
            {children}
          </p>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 border-t border-gray-100 px-6 py-4">
          <button
            type="button"
            onClick={handleConfirm}
            disabled={loading}
            className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary/90 disabled:opacity-50"
          >
            {loading ? "처리 중..." : "확인"}
          </button>
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-50 disabled:opacity-50"
          >
            취소
          </button>
        </div>
      </div>
    </ModalLayout>
  );
};

export default ConfirmModal;
